import GroupGuesser from "./GroupGuesser";

export default GroupGuesser;